import React from 'react';
import '../../css/spinner.css';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/country-dropdown-new'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...dependencies, ...props });
  };

  return {
    html,
    validators: [
      function (state) {
        if (state.error || !state.firstBlurred) {
          return state.error;
        }

        return false;
      },
    ],
    config: { validators: ['mandatory'] },
  };
}
